require('./hireSelectCardLimit.scss');

// @ vendors
const React = require('react');
// const PropTypes = require('prop-types');
// @ components
import { SelectList } from 'components/SelectList/SelectList';
// @ utilities
import { FormattedText, formatText } from 'core/i18n';

class HireSelectCardLimit extends React.Component {
    constructor(props) {
        super(props);

        this.minOptionsList = [
            { label: '0,00 €', value: 0 },
            { label: '5,00 €', value: 5 },
            { label: '10,00 €', value: 10 },
            { label: '20,00 €', value: 20 },
            { label: '30,00 €', value: 30 },
            { label: '40,00 €', value: 40 },
        ];

        this.defaultMaxOptionsList = [
            { label: 'SIN LIMITE', value: 999 },
            { label: '3,00 €', value: 3 },
            { label: '5,00 €', value: 5 },
            { label: '10,00 €', value: 10 },
            { label: '20,00 €', value: 20 },
            { label: '40,00 €', value: 40 },
            { label: '60,00 €', value: 60 },
            { label: '80,00 €', value: 80 },
            { label: '100,00 €', value: 100 },
        ];

        this.updateMaxAmount = this.updateMaxAmount.bind(this);
    }

    componentDidMount() {
        const { userProfile, formActions } = this.props;

        if (!userProfile.ngoMinAmount) {
            formActions.change('userProfile.ngoMinAmount', this.minOptionsList[0].value);
        }

        if (!userProfile.ngoMaxAmount) {
            formActions.change('userProfile.ngoMaxAmount', this.defaultMaxOptionsList[0].value);
        }
    }

    buildMaxOptionList() {
        const { userProfile } = this.props;
        const defaultMaxOptionsList = this.defaultMaxOptionsList;
        const count = defaultMaxOptionsList.length;
        let maxOptionsList = [];

        if (userProfile.ngoMinAmount) {
            maxOptionsList.push({ label: 'SIN LIMITE', value: 999 });

            for (let i = 1; i < count; i++) {
                if (defaultMaxOptionsList[i].value >= userProfile.ngoMinAmount) {
                    maxOptionsList.push(defaultMaxOptionsList[i]);
                }
            }
        } else {
            maxOptionsList = this.defaultMaxOptionsList;
        }

        return maxOptionsList;
    }

    updateMaxAmount(value) {
        const { userProfile, formActions } = this.props;
        const defaultMaxOptionsList = this.defaultMaxOptionsList;
        const count = defaultMaxOptionsList.length;

        if (userProfile.ngoMaxAmount < value) {
            for (let i = 1; i < count; i++) {
                if (defaultMaxOptionsList[i].value >= value) {
                    formActions.change('userProfile.ngoMaxAmount', defaultMaxOptionsList[i].value);
                    break;
                }
            }
        }
    }

    render() {
        const minOptionsList = this.minOptionsList;
        const maxOptionsList = this.buildMaxOptionList();
        const updateMaxAmount = this.updateMaxAmount;

        return (
            <div className="hire-select-card-limit">
                <div className="hire-select-card-limit__title">
                    <FormattedText value="hireSelectCardLimit-title" />
                </div>
                <div className="hire-select-card-limit__amount-list">
                    <div className="hire-select-card-limit__amount-list-min">
                        <SelectList
                            {...this.props}
                            label={formatText('hireSelectCardLimit-minAmountLabel')}
                            messagesError={{ required: formatText('validation-fieldRequired') }}
                            name="ngoMinAmount_value"
                            onChange={function (value) {
                                updateMaxAmount(value);
                            }}
                            optionsList={minOptionsList}
                            placeholder={formatText('hireSelectCardLimit-minAmountPlaceholder')}
                            profileModel="userProfile.ngoMinAmount"
                            required
                            validations={{
                                required: value => value,
                            }}
                            defaultValue={minOptionsList[0]}
                        />
                    </div>
                    <div>
                        <SelectList
                            {...this.props}
                            label={formatText('hireSelectCardLimit-maxAmountLabel')}
                            messagesError={{ required: formatText('validation-fieldRequired') }}
                            name="ngoMinAmount_value"
                            optionsList={maxOptionsList}
                            placeholder={formatText('hireSelectCardLimit-maxAmountPlaceholder')}
                            profileModel="userProfile.ngoMaxAmount"
                            required
                            validations={{
                                required: value => value,
                            }}
                            defaultValue={maxOptionsList[0]}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

HireSelectCardLimit.propTypes = {};

module.exports = HireSelectCardLimit;
